import { FC } from 'react';
import { clx } from 'Utils';

import styles from 'partials/card/subscription-card.module.scss';

const skeletonStyle: React.CSSProperties = {
	minHeight: 20,
	width: '100px'
};

export const SkeletonInvoicePayment: FC = () => {
	return (
		<div>
			<h6 className="text-gray-3 mb-3 fs-6 fw-400 d-flex align-items-center justify-content-between">
				<span className="skeletonStyle" style={skeletonStyle} />
				<span
					className="skeletonStyle"
					style={{ ...skeletonStyle, width: 60 }}
				/>
			</h6>
			<div className={clx(styles.row, 'justify-content-between')}>
				<span className={styles.rowLabel}>
					<span className="skeletonStyle" style={skeletonStyle} />
				</span>
				<span>
					<span className="skeletonStyle" style={skeletonStyle} />
				</span>
			</div>
			<div
				className={clx(styles.row, 'justify-content-between border-0')}>
				<span className={styles.rowLabel}>
					<span className="skeletonStyle" style={skeletonStyle} />
				</span>
				<span>
					<span className="skeletonStyle" style={skeletonStyle} />
				</span>
			</div>
			<div className={clx(styles.row, 'justify-content-between')}>
				<span className={styles.rowLabel}>
					<span className="skeletonStyle" style={skeletonStyle} />
				</span>
				<span>
					<span className="skeletonStyle" style={skeletonStyle} />
				</span>
			</div>
		</div>
	);
};
